import './App.css';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Header from "./Store App/Components/Header";
import Footer from './Store App/Components/Footer';
import Routing from './Store App/Components/Routing';
import ScrollToTop from './Store App/ScrollToTop';

import { BrowserRouter, useLocation } from 'react-router-dom';
import { CartProvider } from './Store App/Components/CartContext';
import { createContext, useState, useEffect, useRef } from 'react';
import axios from "axios";

export const loginstatus = createContext();

function VisitorTracker() {

const location = useLocation();
const startTimeRef = useRef(Date.now());

useEffect(() => {

// Track visitor only once per session
const visited = sessionStorage.getItem("visitorTracked");

if (!visited) {
  sessionStorage.setItem("visitorTracked", "true");

  axios.post("https://ezer-eventapp.onrender.com/visitors/track", {
    page: location.pathname
  }).catch(err => console.log(err));
}

// reset timer when page changes
startTimeRef.current = Date.now();

const sendDuration = () => {

  const duration = Math.floor((Date.now() - startTimeRef.current) / 1000);

  navigator.sendBeacon(
    "https://ezer-eventapp.onrender.com/visitors/session",
    new Blob(
      [JSON.stringify({
        page: location.pathname,
        duration: duration
      })],
      { type: "application/json" }
    )
  );

};

// fires when tab closes or page hidden
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "hidden") {
    sendDuration();
  }
});

return () => {
  sendDuration(); // send duration when route changes
  window.removeEventListener("pagehide", sendDuration);
};

}, [location.pathname]);

return null;
}

function App() {

const [login, setLogin] = useState(false);

return ( <BrowserRouter>

  <VisitorTracker />

  <CartProvider>
    <loginstatus.Provider value={[login, setLogin]}>

      <ScrollToTop />
      <Header />
      <Routing />
      <Footer />

    </loginstatus.Provider>
  </CartProvider>

</BrowserRouter>

);
}

export default App;
